import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Pull = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.75 5.37197C5.62389 5.06309 6.25 4.22966 6.25 3.25C6.25 2.00736 5.24264 1 4 1C2.75736 1 1.75 2.00736 1.75 3.25C1.75 4.22966 2.37611 5.06309 3.25 5.37197V10.628C2.37611 10.9369 1.75 11.7703 1.75 12.75C1.75 13.9926 2.75736 15 4 15C5.24264 15 6.25 13.9926 6.25 12.75C6.25 11.7703 5.62389 10.9369 4.75 10.628V5.37197ZM4.75 3.25C4.75 3.66421 4.41421 4 4 4C3.58579 4 3.25 3.66421 3.25 3.25C3.25 2.83579 3.58579 2.5 4 2.5C4.41421 2.5 4.75 2.83579 4.75 3.25ZM4.75 12.75C4.75 13.1642 4.41421 13.5 4 13.5C3.58579 13.5 3.25 13.1642 3.25 12.75C3.25 12.3358 3.58579 12 4 12C4.41421 12 4.75 12.3358 4.75 12.75Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 15C13.2426 15 14.25 13.9926 14.25 12.75C14.25 11.7703 13.6239 10.9369 12.75 10.628V9.65685C12.75 8.39708 12.2496 7.1889 11.3588 6.2981L9.56066 4.5H12V3H7V8H8.5V5.56066L10.2981 7.35876C10.9076 7.96825 11.25 8.7949 11.25 9.65685V10.628C10.3761 10.9369 9.75 11.7703 9.75 12.75C9.75 13.9926 10.7574 15 12 15ZM12 13.5C12.4142 13.5 12.75 13.1642 12.75 12.75C12.75 12.3358 12.4142 12 12 12C11.5858 12 11.25 12.3358 11.25 12.75C11.25 13.1642 11.5858 13.5 12 13.5Z"
      fill="currentColor"
    />
  </Icon>
));

export default Pull;
